import { i18n } from "@core/plugins/i18n";
import { JavascriptHelpers } from "@core/helpers";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { AuthenticationManager } from "@core/managers/authentication.manager";
import { EventManager } from "@core/managers/event.manager";
import { CORE_EVENTS } from "@core/constants";
import { ETAB_ROUTES } from "@etab/config";
import { Logger } from "@core/helpers/logger.helpers";

/**
 * Handle errors and act accordingly
 */
export function errorsHandler({ router }) {
  EventManager.on(CORE_EVENTS.ERROR_401, () => handle401({ router }));
  EventManager.on(CORE_EVENTS.ERROR_403, ({ message } = {}) => handle403({ message, router }));
  EventManager.on(CORE_EVENTS.FORCE_UPDATE, () => handleForceUpdate({ router }));
}

function handle401({ router } = {}) {
  notifyAccountIssue();
}

function handle403({ message, router } = {}) {
  if (message) {
    NotificationsManager.contactEtabSupport({ message });
  }
}

async function handleForceUpdate({ router } = {}) {
  const forceUpdateRoute = { name: ETAB_ROUTES.update.name };
  // on next route update
  try {
    await router.isReady();
    router.replace(forceUpdateRoute).catch((suppressedError) => {});
  } catch (err) {
    Logger.error("Force update redirection failed");
  }
}

function notifyAccountIssue() {
  return NotificationsManager.error({
    message: "ERRORS.@ACCOUNT_ISSUE",
    options: {
      timeout: 5000,
      closeBtn: false,
      actions: [
        {
          color: "white",
          label: i18n.global.t("CORE.BUTTONS.@CONNECT_AGAIN"),
          handler: async () => {
            await AuthenticationManager.logout();
            // reload in order to clear everything
            JavascriptHelpers.reloadWindow();
          },
        },
        {
          color: "white",
          icon: "icon-f-x",
          handler: () => {}, // close
        },
      ],
    },
  });
}
